module.exports = __webpack_public_path__ + "static/img/starter-kit.0ec2f61.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/starter-kit.png
 ** module id = 32
 ** module chunks = 1
 **/